import { BaseFetch } from "../main-model"
export default class ReportTraditionModel extends BaseFetch {
    getReportTraditionYearBy = (data) =>
    this.authFetch({
      url: "report-tradition/getReportTraditionYearBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportTraditionMonthBy = (data) =>
    this.authFetch({
      url: "report-tradition/getReportTraditionMonthBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportTraditionBy = (data) =>
    this.authFetch({
      url: "report-tradition/getReportTraditionBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
